import React, { useEffect } from "react";
import classes from "./SystemUpdateNotice.module.css";
import { ReactComponent as PostmanLogo } from "../../assets/PostmanLogo2.svg";

const GEAR_TEETH = [0, 45, 90, 135, 180, 225, 270, 315];

const PAGE_TITLE = "Sistemi është duke u përditësuar";

/**
 * The maintenance screen: a single self-contained page shown in place of the whole application.
 *
 * `src/index.tsx` renders this **instead of** `<BrowserRouter><Provider><App/></Provider>` when
 * `MAINTENANCE_MODE` is on, which is what makes it a hard block rather than a banner:
 *
 * - there is no router, so every URL — including a deep link such as `/orders/123` that nginx
 *   answers with `index.html` — lands here and nowhere else;
 * - there is no Redux store, no SignalR hub and no page mounted behind it, so the front end
 *   makes no API calls at all while the back end is being updated.
 *
 * Keep it dependency-free (no antd, no Tailwind classes, no country config): it has to render
 * correctly before anything else in the app has had a chance to initialise.
 */
const SystemUpdateNotice = () => {
	useEffect(() => {
		document.title = `${PAGE_TITLE} · Postman`;
	}, []);

	return (
		<div className={classes.screen} role="status" aria-live="polite">
			<div className={classes.card}>
				<PostmanLogo className={classes.logo} />

				<div className={classes.iconWrap} aria-hidden="true">
					<span className={classes.pulse} />
					<span
						className={`${classes.pulse} ${classes.pulseDelayed}`}
					/>
					<span className={classes.disc}>
						<svg
							className={classes.gear}
							viewBox="0 0 48 48"
							focusable="false"
						>
							{/*
							 * The gear is punched out of a solid fill so the
							 * hub is transparent and the disc gradient shows
							 * through it.
							 */}
							<mask id="systemUpdateGear">
								<rect width="48" height="48" fill="black" />
								<g fill="white">
									{GEAR_TEETH.map((angle) => (
										<rect
											key={angle}
											x="21.25"
											y="2"
											width="5.5"
											height="11"
											rx="2.75"
											transform={`rotate(${angle} 24 24)`}
										/>
									))}
									<circle cx="24" cy="24" r="15" />
								</g>
								<circle cx="24" cy="24" r="6.25" fill="black" />
							</mask>
							<rect
								width="48"
								height="48"
								fill="currentColor"
								mask="url(#systemUpdateGear)"
							/>
						</svg>
					</span>
				</div>

				<span className={classes.badge}>Mirëmbajtje</span>
				<h1 className={classes.title}>{PAGE_TITLE}</h1>
				<p className={classes.message}>
					Po kryejmë disa përmirësime në sistem. Shërbimi do të jetë
					përsëri i disponueshëm së shpejti.
				</p>

				<div className={classes.progress} aria-hidden="true">
					<span className={classes.progressBar} />
				</div>

				<p className={classes.footnote}>
					Faleminderit për durimin dhe mirëkuptimin tuaj.
				</p>
			</div>
		</div>
	);
};

export default SystemUpdateNotice;
